import { createSlice, PayloadAction, Dispatch } from '@reduxjs/toolkit';
import { apiInit, exportQueryList, getCommonConfigList } from "src/api/system";
import { setUsername } from '../user/user.store';
import {AppDispatch, AppState} from "../index";

const initialState: any = {
  isDropdownVisible: false,
  exportList: [],
  flatMenuMap:{},
  TinyEditorToken: "",
  imageUrl: "",
};

const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    setInit(state, action: PayloadAction<Partial<any>>) {
      Object.assign(state, action.payload);
    },
    openDropdown(state) {
      state.isDropdownVisible = true;
    },
    closeDropdown(state) {
      state.isDropdownVisible = false;
    },
    setExportList(state, action: PayloadAction<Partial<any>>) {
      state.exportList = action.payload.rsData;
    },
    setTinyEditorToken(state,action){
      state.TinyEditorToken = action.payload;
    },
    setImageUrl(state,action){
      state.imageUrl = action.payload;
    },
    setFlatMenuMap(state,action){
      state.flatMenuMap = action.payload;
    }
  }
});

export const { setInit, openDropdown, closeDropdown, setExportList, setTinyEditorToken, setFlatMenuMap, setImageUrl } = systemSlice.actions;

export default systemSlice.reducer;


export const initAsync = () => {
  const flatMenuMap = {};
  const formatFlatMap = (obj: Record<string, any>) => {
    flatMenuMap[obj.menuLink] = obj;
    if ("subMenu" in obj) {
      obj.subMenu.forEach((subObj) => {
        formatFlatMap(subObj);
      })
    }
  };
  return async (dispatch: Dispatch) => {
    const result : any = await apiInit();
    if (result?.success) {
      result?.menuList?.forEach((menuObj) => {
        formatFlatMap(menuObj)
      })
      dispatch(setInit(result));
      dispatch(
        setUsername({
          name: (result as any).userInfo.systemName
        })
      );
      dispatch(setFlatMenuMap(flatMenuMap))
    }
    return result;
  };
};

export const initTinyToken = () => {
  return async (dispatch: Dispatch) => {
    // const result = await getWebsiteConfigList({ pageSize: 1000 });
    const result = await getCommonConfigList()
    if (result?.success) {
      const configList = result.rsData;
      const TinyEditorToken = configList.find(config =>config.configCode === "TinyEditorToken")?.configVal;
      const imageUrl = configList.find(config =>config.configCode === "imageUrl")?.configVal;
      dispatch(setTinyEditorToken(TinyEditorToken));
      dispatch(setImageUrl(imageUrl));
    }
  };
};

export const pollExportQueryFileList = () => {
  return async (dispatch: AppDispatch, getState: () => AppState): Promise<void> => {
    try {
      const result = await exportQueryList();
      dispatch(setExportList(result || { rsData: [] }));
    } catch (error) {
      console.error('Failed to poll export query file list:', error);
    }
  };
};

export const reloadDropdown = (open: boolean) => {
  return async (dispatch: AppDispatch, getState: () => AppState): Promise<void> => {
    try {
      await dispatch(pollExportQueryFileList());
      if (open) {
       dispatch(openDropdown());
      }
    } catch (error) {
      console.error('Failed to reload dropdown:', error);
    }
  };
};
